import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BiletcategoryComponent } from "../home/biletcategory/biletcategory.component";
import { DashboardComponent } from "../home/dashboard/dashboard.component";
import { BookDetailComponent } from "../home/book-detail/book-detail.component";
import { QuizCategoryDetailComponent } from "../home/quiz-category-detail/quiz-category-detail.component";
import { MainComponent } from './main.component';
import { AuthGuard } from '../_guards';
import { QuizCategoriesComponent } from '../home/quiz-categories/quiz-categories.component';
import { SearchResultsComponent } from '../home/search-results/search-results.component';

const MainRoutes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'quiz', component: QuizCategoriesComponent },
      { path: 'quiz/:code', component: QuizCategoryDetailComponent },
      // { path: 'main/:code/:id', component: BookDetailComponent },
      //  { path: 'main/:code', component: BiletcategoryComponent },
      { path: 'main/book-detail', component: BookDetailComponent },
      { path: 'main/list-category', component: BiletcategoryComponent },
      { path: 'demo/book-detail', component: BookDetailComponent },
      { path: 'demo/list-category', component: BiletcategoryComponent },
      // { path: 'demo/:code/:id', component: BookDetailComponent },
      { path: 'demo/search-results', component: SearchResultsComponent },
      { path: 'main/search-results', component: SearchResultsComponent },
      { path: '', component: DashboardComponent },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(MainRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class MainRoutingModule { }
